import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';

class CustomcardfieldInfo extends React.Component{

    render(){

        let fieldType = this.props.customcardfield.attributes.type_;
        let fieldDefinition = this.props.customcardfield.attributes.name;
        let referenceField = this.props.customcardfield.attributes.reference_field;
        let fieldValue = this.props.cardsGroup.attributes[referenceField];
        if (referenceField === 'description' && this.props.card) {
            fieldValue = this.props.card.attributes.description;
        }
        if (!fieldValue) fieldValue = '-';
        if (fieldType === 'boolean') {
            if (typeof fieldValue === 'string') {
                fieldValue = fieldValue.toLowerCase() === 'true';
            }
            fieldValue = <Checkbox checked={fieldValue} color="primary" disabled/>;
        }

        return (
            <div className='info-container'>
                <p className='card-text'>{ fieldDefinition }</p>
                <span className='text card-description'>{ fieldValue }</span>
            </div>
        );
    }
}

export default CustomcardfieldInfo;